import { BAILocale } from '.';
import mn_MN from 'antd/es/locale/mn_MN';

const localeValue: BAILocale = {
  lang: 'mn',
  antdLocale: mn_MN,
};

export default localeValue;
